import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrainingModeBannerComponent } from './training-mode-banner.component';

@NgModule({
  declarations: [TrainingModeBannerComponent],
  imports: [CommonModule],
  exports: [TrainingModeBannerComponent]
})
export class TrainingModeBannerComponentModule {}
